var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('div',{staticClass:"mainInfo"},[_c('img',{staticClass:"logo",attrs:{"alt":"Servus, Region Logo","title":"Servus, Region Logo","src":require("../assets/cart.png")}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_c('ImageButton',{attrs:{"image":"svg/menu.svg","altText":"Open Menu"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }